// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"dc414a73","453":"eb570f4f","905":"c45bb5b8"}[chunkId] + ".chunk.js";
};